import { render, staticRenderFns } from "./cyber-corner.vue?vue&type=template&id=620b75d2&scoped=true"
import script from "./cyber-corner.vue?vue&type=script&lang=js"
export * from "./cyber-corner.vue?vue&type=script&lang=js"
import style0 from "./cyber-corner.vue?vue&type=style&index=0&id=620b75d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620b75d2",
  null
  
)

export default component.exports